import { render, staticRenderFns } from "./ChatUsersComponent.vue?vue&type=template&id=e3460b94&scoped=true"
import script from "./ChatUsersComponent.vue?vue&type=script&lang=js"
export * from "./ChatUsersComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatUsersComponent.vue?vue&type=style&index=0&id=e3460b94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3460b94",
  null
  
)

export default component.exports